"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as l } from "react";
import m from "../components/Icon/SvgIcon.js";
const t = (o) => /* @__PURE__ */ a(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M17.964 6.802a3.25 3.25 0 0 1 .87 6.38l.001.39v.616a.2.2 0 0 0 .056.138l.801.835a.2.2 0 0 1 .002.274l-.806.872a.2.2 0 0 0-.053.135v.535a.2.2 0 0 0 .056.14l.792.816a.2.2 0 0 1-.006.284l-1.588 1.514a.2.2 0 0 1-.262.013l-.658-.517a.2.2 0 0 1-.077-.157v-5.888a3.25 3.25 0 0 1 .872-6.38m-5.726 5.465c1.689 0 3.05 1.395 3.05 3.087v2.13a.625.625 0 1 1-1.25 0v-2.13c0-1.02-.819-1.837-1.8-1.837H5.931c-.982 0-1.801.818-1.801 1.837v2.13a.625.625 0 1 1-1.25 0v-2.13c0-1.692 1.362-3.087 3.05-3.087zM9.09 4.179c1.918 0 3.428 1.615 3.429 3.55 0 1.936-1.51 3.551-3.43 3.551-1.918 0-3.428-1.615-3.428-3.55 0-1.936 1.51-3.551 3.429-3.551m0 1.25c-1.178 0-2.179 1.004-2.179 2.3 0 1.297 1 2.301 2.179 2.301s2.179-1.004 2.179-2.3c0-1.297-1.001-2.301-2.18-2.301Zm8.873 2.518a.81.81 0 1 0 .002 1.621.81.81 0 0 0-.002-1.62Z"
      }
    )
  }
), e = l(t);
export {
  e as Passkey,
  e as default
};
